import { render, staticRenderFns } from "./FloatImageAppearance.vue?vue&type=template&id=4501013a&scoped=true&"
import script from "./FloatImageAppearance.vue?vue&type=script&lang=js&"
export * from "./FloatImageAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501013a",
  null
  
)

export default component.exports